import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { AdditionalInsurers } from '../../../shared/models/contract/additional-insurer.model';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { CommonService } from '../../../shared/service/common.service';
import { ValidationUiService } from '../../../shared/service/ui/validation-ui';
import { AdditionalInsurersValidationService } from '../../service/additional-insurer-validation.service';

@Component({
  selector: 'app-additional-insured-dob',
  templateUrl: './additional-insured-dob.component.html'
})
export class AdditionalInsuredDobComponent implements OnInit {
  @Output() public submitAnswer = new EventEmitter<AdditionalInsurers>();
  @Input() contractType: ContractType;

  insurers: AdditionalInsurers[] = [];
  counter = 2;

  constructor(
    private additionalInsurersValidationService: AdditionalInsurersValidationService,
    private commonService: CommonService,
    private validationUiService: ValidationUiService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    if (this.insurers.length === 0) {
      this.insurers = this.contractType.policyHolder.personType
        .filter((x) => x.number > 1)
        .map((s) => ({
          date: this.commonService.customDateFormat(s.birthDate, 'dd/MM/yyyy'),
          birthAgeInYears: s.birthAgeInYears,
          number: s.number
        })) as AdditionalInsurers[];
    }
    this.additionalInsurersValidationService.addInsurers$.subscribe({
      next: (insurer) => {
        if (this.insurers.length < 8) {
          insurer.number = this.counter;
          this.insurers.push(insurer);
          this.counter++;
        }
      }
    });
    this.additionalInsurersValidationService.removeInsurers$.subscribe({
      next: () => {
        if (this.insurers.length > 0) {
          this.insurers.pop();
          this.counter--;
        }
      }
    });
    this.additionalInsurersValidationService.insurersValid$.subscribe({
      next: (error) => {
        if (error && error.isInValid) {
          if (this.validationUiService.isInsuredSubmit) {
            this.insurers[error.index].invalid = error.isInValid;
            document.getElementById('txtDate' + (error.index + 2))?.classList?.add('error');
            const element = this.document.getElementById('errorContainer') as HTMLElement;
            element.innerHTML = error.errorMessage;
            element?.classList?.remove('hidden');
          }
        } else {
          this.insurers[error.index].invalid = error.isInValid;
          document.getElementById('txtDate' + (error.index + 2))?.classList?.remove('error');
          if (this.insurers.filter((a) => a.invalid === true).length > 0) {
            // Adding this line because we are showing single error message for all the additional insurer dob
            (this.document.getElementById('errorContainer') as HTMLInputElement).innerHTML = error.errorMessage;
          } else {
            (this.document.getElementById('errorContainer') as HTMLInputElement).innerHTML = error.errorMessage;
          }
        }
      }
    });
  }

  onSubmitAnswer(insurer: AdditionalInsurers, index: number) {
    insurer.index = index;
    this.submitAnswer.emit(insurer);
    this.additionalInsurersValidationService.isInValid(this.contractType);
  }
}
